module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"slogan":"Plan your bag.","login":"Login","test_first":"Try without account","more":"More information"},"de":{"slogan":"Plane dein Gepäck","login":"Einloggen","test_first":"Ohne Account testen","more":"Mehr Informationen"}}')
  delete Component.options._Ctor
}
